import axios, { AxiosError, AxiosRequestConfig } from "axios"
import {
    getUserCredentials,
    adminApiUrl
} from "../../axiosUtils"
import { InlfuencerData } from "../../../../redux/slices/components/TrackingLinksInfluencers/TrackingLinksInfluencersSlice"

export const getInfluencersTrackingLinksData = () => {
    return new Promise((resolve: (value: InlfuencerData) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
                params: { page: 1, limit: 60 }
            };
            axios.get(`${adminApiUrl}/v1/tracking-links`, config)
            .then((res) => {
                console.log("data", res.data)
                resolve(res.data)
            })
            .catch((error: AxiosError) => { 
                console.log("Error: ", `${adminApiUrl}/v1/tracking-links`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 


export type CreateTrackingLinkBody = {
    id: string
    name: string
}

export const createTrackingLinksData = (body: CreateTrackingLinkBody) => {
    return new Promise((resolve: (value: InlfuencerData) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
            };

            axios.post(`${adminApiUrl}/v1/tracking-links`, body, config)
            .then((res) => {
                console.log("data", res.data)
                resolve(res.data)
            })
            .catch((error: AxiosError) => { 
                console.log("Error: ", `${adminApiUrl}/v1/tracking-links`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 



type UpdateTrackingLinkBody = {
    name: string
}

export const updateTrackingLinksData = (id: string, body: UpdateTrackingLinkBody) => {
    return new Promise((resolve: (value: InlfuencerData) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
            };

            axios.patch(`${adminApiUrl}/v1/tracking-links/${id}`, body, config)
            .then((res) => {
                console.log("data", res.data)
                resolve(res.data)
            })
            .catch((error: AxiosError) => { 
                console.log("Error: ", `${adminApiUrl}/v1/tracking-links/${id}`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 


export const deleteTrackingLinksData = (id: string) => {
    return new Promise((resolve: (value: InlfuencerData) => void, reject) => {
        getUserCredentials()
        .then((session) => {
            const token = session.idToken;
            const config: AxiosRequestConfig = { 
                headers: { Authorization: `Bearer ${token}`, },
            };

            axios.delete(`${adminApiUrl}/v1/tracking-links/${id}`, config)
            .then((res) => {
                console.log("data", res.data)
                resolve(res.data)
            })
            .catch((error: AxiosError) => { 
                console.log("Error: ", `${adminApiUrl}/v1/tracking-links/${id}`, error); 
                reject(error) 
            })
        }).catch((error: any) => {
            reject(error)
        })
    })
} 
